import { BaseLayer } from './BaseLayer'
import { apiFzu } from '@/apiFzu'
import { drawDwrtCenterline, drawDwrtPolygon, drawPurpleLine } from './DwrtRenderUtils'
import * as Cesium from 'cesium'

export class DwrtLayer extends BaseLayer {
  layername: string = '航道(矢量)'
  key: string = 'dwrtshp'
  private centerlinePrimitives: Cesium.GroundPolylinePrimitive[] = []

  async render(): Promise<void> {
    const geojsons = await this.loadGeojson()

    // 航道面
    drawDwrtPolygon(geojsons[2]).forEach((p) => {
      this.layer.primitiveCollection.add(p)
    })

    // 中心线
    this.centerlinePrimitives = drawDwrtCenterline(geojsons[0])
    this.centerlinePrimitives.forEach((p) => {
      this.layer.primitiveCollection.add(p)
    })

    // 边缘线
    drawPurpleLine(geojsons[1]).forEach((p) => {
      this.layer.primitiveCollection.add(p)
    })

    // 添加相机高度监听
    if (this._viewer) {
      this._viewer.scene.postRender.addEventListener(this.onCameraChange, this)
      this.on('destroy', () => {
        if (this._viewer) {
          this._viewer.scene.postRender.removeEventListener(this.onCameraChange, this)
        }
      })
    }
  }

  private onCameraChange() {
    if (!this._viewer) return

    // 获取相机高度
    const cameraHeight = this._viewer.camera.positionCartographic.height

    // 根据高度控制中心线显示
    this.centerlinePrimitives.forEach((primitive) => {
      primitive.show = cameraHeight < 10000
    })
  }

  private async loadGeojson() {
    const res = await Promise.all([
      apiFzu.dwrt.dwrtControllerGetClList().then((res) => res.data), // 中心线
      apiFzu.dwrt.dwrtControllerGetPcList().then((res) => res.data), // 边缘线
      apiFzu.dwrt.dwrtControllerGetPtList().then((res) => res.data), // 航道面
    ])
    return res
  }
}
